export default __webpack_public_path__ + "static/media/contacts.ec809278.mp4";